import { requestInterceptors, SessionOutInterceptor, ReportRequestInterceptor, AbortRequestInterceptor } from '@tencent/wphk-base-request';
import { RequestConfig, login } from '@tencent/wphk-act-base-api';
import { showDialog, hideDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '@/i18n';
import { hideLoading } from '@tencent/wphk-act-base-ui';

/**
 * 页面进行登陆操作
 */
function doLogin() {
  login.login({ scope: false, domain: RequestConfig.WX_LOGIN_DOMAIN, force: true });
}

/**
 * 处理登陆超时
 */
export function initLoginInterceptors() {
  requestInterceptors
    .use(new SessionOutInterceptor({
      errCodes: [`${RequestConfig.NOT_DEFAULT_LOGIN}`],
      handle({ isLoggedIn }) {
      // 操作引发的超时失效，需要弹框引导登录
        if (isLoggedIn) {
        // 一般ajax请求前会先展示loading，由于登陆拦截会卡住后续流程，
        // 这里需要先手动关闭loading，避免loading和下面的登陆提示弹框同时出现
          hideLoading();
          showDialog({
            title: i18n('你的登录已失效，请重新登录。'),
            btns: [
              {
                text: i18n('确定'),
                click() {
                  hideDialog();
                  doLogin();
                },
              },
            ],
          });
          return;
        }
        // 页面初始化时登陆失效，直接去进行登陆操作
        doLogin();
      },
    }))
    .use(new ReportRequestInterceptor())
    .use(new AbortRequestInterceptor());
}
